import { Skeleton } from 'antd';

export function NavbarSkeleton() {
  return (
    <header className="bg-blue fixed top-0 left-0 w-full z-20 animate-pulse">
      <nav className="flex items-center justify-between px-8 pt-4 pb-4 sm:py-4 sm:px-6">
        <div className="flex items-center">
          <Skeleton.Input active size="small" className="h-8 w-24 rounded-lg" />
        </div>

        <div className="flex items-center">
          <div>
            <Skeleton.Avatar active size={40} shape="circle" />
          </div>
        </div>
      </nav>
    </header>
  );
}
